const common = {
  nav: {
    home: "Home",
    services: "Services",
    about: "About",
    testimonials: "Testimonials",
    contact: "Contact",
    getQuote: "Get a Quote",
  },
  footer: {
    tagline: "Your home, our priority.",
    services: "Services",
    company: "Company",
    contact: "Contact",
    rights: "© 2026 Adry & Mich Cleaning and Handyman Service. All rights reserved.",
    privacy: "Privacy",
    terms: "Terms",
    newsletter: "Get Special Offers",
    newsletterPlaceholder: "Your email address",
    subscribe: "Subscribe",
    schedule: "Mon – Sat: 8:00 AM – 4:00 PM",
    payment: "Payment: Cash · Zelle · Check",
  },
  cta: {
    requestQuote: "Request a Quote",
    whatsapp: "WhatsApp Us",
    callNow: "Call Now",
    learnMore: "Learn More",
    viewServices: "View Services",
    bookNow: "Book Now",
    sendMessage: "Send Message",
    getStarted: "Get Started",
  },
  contact: {
    phone: "(561) 262-6118",
    email: "adrimich7778@hotmail.com",
    address: "10639 Misty Lane, Royal Palm Beach, FL 33411",
  },
};

export default common;
